import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useUIStore } from '@/stores/uiStore'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { ToastContainer } from '@/components/ui/Toast'

interface MainLayoutProps {
  children: React.ReactNode
  fullWidth?: boolean
}

export function MainLayout({ children, fullWidth = false }: MainLayoutProps) {
  const { sidebarCollapsed, isMobile, setIsMobile } = useUIStore()

  // Handle responsive behavior
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [setIsMobile])

  const mainMarginLeft = isMobile ? '0' : sidebarCollapsed ? '64px' : '280px'

  return (
    <div className="min-h-screen bg-surface-100 dark:bg-zinc-950">
      {/* Header */}
      <Header />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <motion.main
        initial={false}
        animate={{
          marginLeft: mainMarginLeft
        }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="pt-16 min-h-screen"
      >
        {fullWidth ? (
          <div className="h-[calc(100vh-64px)]">
            {children}
          </div>
        ) : (
          <div className="p-4 md:p-8">
            {children}
          </div>
        )}
      </motion.main>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  )
}
